import { CheckmarkCircle16Filled, PlugConnected20Regular } from '@/components/Icon'
import styles from './customModelDialog.module.scss'

/** One provider: logo, name, and what it's known for. */
export default function ProviderTile({ provider, selected, onSelect }) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      aria-label={provider.label}
      className={`${styles.tile}${selected ? ` ${styles.tileSelected}` : ''}`}
      onClick={onSelect}
    >
      <span className={styles.logo}>
        {provider.iconUrl ? (
          <img src={provider.iconUrl} alt="" loading="lazy" decoding="async" />
        ) : (
          <PlugConnected20Regular aria-hidden />
        )}
      </span>
      <span className={styles.tileText}>
        <span className={styles.tileName}>{provider.label}</span>
        <span className={styles.tileTagline}>{provider.tagline}</span>
      </span>
      {selected ? <CheckmarkCircle16Filled className={styles.tileCheck} aria-hidden /> : null}
    </button>
  )
}
